import { inject } from 'mobx-react';
import * as React from 'react';

import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { UnitsCarousel } from '@shared-ui/lodging-property-offers';
import { useBexApi } from '@shared-ui/bex-api-context';

import { MultiItemStore } from 'src/common/stores/multi-item-store';

import { DeviceType } from 'src/common/__generated__/api';
import { SharedUiWrapperProps, withSharedUiPropertyOffers } from './shared-ui-property-offers';

interface UnitsCarouselProps extends SharedUiWrapperProps {
  multiItem?: MultiItemStore;
}

const UnitsCarouselWrapper: React.FC<UnitsCarouselProps> = inject('multiItem')(({ inputs, multiItem }) => {
  const { context } = useBexApi();
  const isMultiItem = multiItem?.isPackageShoppingPath();

  const numberOfRooms = inputs?.searchCriteria?.primary?.rooms?.length || 1;

  const isMobileOrTablet = context?.device?.type === DeviceType.MOBILE_PHONE || context?.device?.type === DeviceType.MOBILE_TABLET;

  if (numberOfRooms > 1 || isMultiItem || !isMobileOrTablet) {
    return null;
  }

  return (
    <Experiment name="Lodging_PDP_Rooms_Overview_MWeb" logExposure={false}>
      <ExperimentControl />
      <ExperimentVariant bucket={1}>
        <UnitsCarousel inputs={inputs} skipSsr={true} />
      </ExperimentVariant>
    </Experiment>
  );
});

UnitsCarouselWrapper.displayName = 'SharedUiUnitsCarouselWrapper';
export const SharedUiUnitsCarouselWrapper = withSharedUiPropertyOffers(UnitsCarouselWrapper);
